export default __webpack_public_path__ + "static/media/calendarWhite.e052bd5d.svg";